// Round-length preference for tap battles.
// Persisted to localStorage so the Battle Hub, pre-battle lobby, and the
// live tap arena all agree on the same clock without having to plumb the
// value through URL params or route state.

export const ROUND_LENGTHS = [
  { key: 'casual', seconds: 180, label: 'Casual',  hint: 'Cinematic pace' },
  { key: 'rapid',  seconds:  90, label: 'Rapid',   hint: 'Balanced' },
  { key: 'blitz',  seconds:  45, label: 'Blitz',   hint: 'Speed-run' },
];

const KEY = 'wq_round_length';
const DEFAULT = 'casual';

export function getRoundLengthKey() {
  try {
    const v = localStorage.getItem(KEY);
    return ROUND_LENGTHS.some(r => r.key === v) ? v : DEFAULT;
  } catch {
    return DEFAULT;
  }
}

export function setRoundLengthKey(key) {
  if (!ROUND_LENGTHS.some(r => r.key === key)) return;
  try { localStorage.setItem(KEY, key); } catch { /* ignore */ }
  // Broadcast so any listening component (e.g. LiveArena mounted from
  // route state) can react without a full remount.
  try { window.dispatchEvent(new CustomEvent('wq:round-length-changed', { detail: key })); } catch {}
}

export function getRoundSeconds(key = getRoundLengthKey()) {
  const row = ROUND_LENGTHS.find(r => r.key === key);
  return row ? row.seconds : ROUND_LENGTHS[0].seconds;
}
